// modules
import { useDispatch } from 'react-redux';
import { Tooltip } from '@mui/material';
import Reply from '@mui/icons-material/Reply';

// local imports
import { uiActions } from '../../store';
import CustomButton from '../CustomButton';
import { sharedTooltipProps } from '../DeckMap/CustomMapControls/sharedTooltipProps';

/**
 * ShareButton
 *
 * Renders a button that toggles the share dialog in the application.
 *
 * @returns {JSX.Element} The rendered ShareButton component.
 */
export default function ShareButton() {
  const dispatch = useDispatch();

  const handleClick = () => {
    dispatch(uiActions.toggleShareDialog());
  };

  return (
    <Tooltip title="Share" placement="left" {...sharedTooltipProps}>
      <CustomButton
        data-testid="share-button"
        aria-label="Share"
        onClick={handleClick}
        width="90px"
        buttonVariant="standalone"
        sx={{
          position: 'absolute',
          top: 10,
          right: 10,
          textTransform: 'none',
          fontWeight: '600',
          '& .MuiSvgIcon-root': {
            transform: 'scaleX(-1)',
            paddingLeft: '5px',
          },
        }}
      >
        <Reply />
        Share
      </CustomButton>
    </Tooltip>
  );
}
